import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import useAppContext from 'flow/hooks/useAppContext';
import SearchInput from './ui-components/SearchInput';

const DEBOUNCE_WAIT_TIME_MS = 350;

const FilterSearchBar = ({ handleFilter, searchText = '', placeholder }) => {
    const { i18next } = useAppContext();
    const [filterText, setFilterText] = useState(searchText);

    const completeSearchDebounced = debounce(
        handleFilter.bind(this),
        DEBOUNCE_WAIT_TIME_MS,
    );

    const handleInputChange = (event) => {
        setFilterText(event.target.value);
        completeSearchDebounced(event, event.target.value);
    };

    return (
        <SearchInput
            iconKey="search"
            placeholder={placeholder ? placeholder : i18next.t('input.search')}
            onChange={handleInputChange}
            value={filterText}
            className="dark:bg-gray-300"
        />
    );
};

FilterSearchBar.propTypes = {
    handleFilter: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    placeholder: PropTypes.string,
};

export default FilterSearchBar;
